import { AnyARecord } from "node:dns";
import { DataServer } from "../../../../config.axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

interface AlertTimeState {
    alerttime: {
    load: boolean;
    data: [];
  };
}

export const AlertTimeSlice = createSlice({
  name: "alerttime",
  initialState: {
    alerttime: {
      load: false,
      data: [],
    },
  } as AlertTimeState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder
      .addCase(fetchAlertTime.pending, (state: AlertTimeState) => {
        state.alerttime.load = true;
      })
      .addCase(fetchAlertTime.fulfilled, (state: AlertTimeState, action: any) => {
        state.alerttime.data = action.payload;
        state.alerttime.load = false;
      })
      .addCase(fetchAlertTime.rejected, (state: AlertTimeState) => {
        state.alerttime.load = false;
      });
  },
});

export default AlertTimeSlice.reducer;

export const fetchAlertTime = createAsyncThunk(
  "alerttime/fetchAlertTime",
  async (param: {apiParam: {warehouse_id: any}}, thunkAPI) => {
    try {
      const { data } = await DataServer.post(`api/getAlertTime`, {
        warehouse_id: param.apiParam.warehouse_id
      });
      
      return data.data;
    } catch (error) {
    }
  }
);